import { PrimaryRegularButton } from 'components/ReusableComponents/Button/RegularButtons'

import styles from './NewFeatureBox.module.scss'
import { ReactComponent as RocketIcon } from './rocketIcon.svg'

const NewFeatureBox = ({
  title = 'Title describing the new feature',
  desc = <p>And a description</p>,
  buttonText = 'Get started',
  onClickAction
}) => (
  <div className={styles.newFeatureBox}>
    <div className={styles.topPart}>
      <RocketIcon />
    </div>
    <div className={styles.content}>
      <div className={styles.hgroup}>
        {/* <p className={styles.tagline}>New feature!</p> */}
        <h3 className={styles.title}>{title}</h3>
      </div>
      <div className={styles.description}>{desc}</div>
      <PrimaryRegularButton onClick={onClickAction}>{buttonText}</PrimaryRegularButton>
    </div>
  </div>
)

export default NewFeatureBox
